import ApiService from '@/services/api.service'

const StatsService = {

	/**
	 * Retourne les statistiques
	 */
	getStats: async function() {
		
		const response = await ApiService.get('/api/stats')
		return response.data
	},

	/**
	 * Retourne les paramètres des statistiques
	 */
	getSettings: async function() {
		
		const response = await ApiService.get('/api/stats/settings')
		return response.data
	},

	/**
	 * Enregistre les paramètres
	 * 
	 * @param {Object} settings 
	 */
	saveSettings: async function(settings) {
		
		const response = await ApiService.post('/api/stats/settings', settings)
		return response.data
	}
}

export default StatsService